// This is example of menu item without group for horizontal layout. There will be no children.

// third-party
import { FormattedMessage } from 'react-intl';

// assets
import { IconRoute2, IconClock, IconBuildingStore, IconCalendar } from '@tabler/icons';

// type
import { NavItemType } from 'types';

// ==============================|| MENU ITEMS - SAMPLE PAGE ||============================== //

const icons = {
    IconRoute2,
    IconClock,
    IconBuildingStore,
    IconCalendar,
};
const routes: NavItemType = {
    id: 'routes',
    title: <FormattedMessage id="Routes" />,
    type: 'group',
    // caption: <FormattedMessage id="routes-caption" />,
    children: [
            {
                id: 'view-routes',
                title: <FormattedMessage id="Manage routes" />,
                icon: icons.IconRoute2,
                type: 'item',
                url: '/routes',
                target: false
            },
            {
                id: 'pending-routes',
                title: <FormattedMessage id="Pending routes" />,
                icon: icons.IconClock,
                type: 'item',
                url: '/pending-routes',
                target: false
            },
            {
                id: 'marketplace-routes',
                title: <FormattedMessage id="Marketplace routes" />,
                icon: icons.IconBuildingStore,
                type: 'item',
                url: '/marketplace-routes',
                target: false
            },
            {
                id: 'view-route-instances-by-date',
                title: <FormattedMessage id="View routes by date" />, //shortened so it fits in sidebar
                icon: icons.IconCalendar,
                type: 'item',
                url: '/route-instances-by-date',
                target: false
            },
    ]
};

export default routes;
